<template>
  <div id="Home" style="height: 100%;">
    <el-container>
      <!-- Header -->
      <el-header>
        <div style="height: 100%;" class="flex justify-between align-center">
          <img src="../assets/img/homelogo.png" style="width: 131px;height: 28px;">
          <div class="flex align-center" style="height: 100%;">
            <!-- 公告 -->
            <el-button @click="getMsg" id="home-btn">兀兔公告</el-button>

            <!-- 账号、退出 -->
            <span style="color: #333333;font-size: 14px;cursor: pointer;">{{login_name}}</span> &nbsp;/&nbsp;
            <span @click="signOut" style="color: #999999;font-size: 14px;cursor: pointer;">退出</span>
          </div>
        </div>
      </el-header>
      <el-container>
        <!-- Aside -->
        <el-aside id='homeleft' width="200px">
          <!-- 左侧导航栏 -->
          <div @click="gopage(item.id)" :class="current==item.id?'isactive':''" v-for="(item,index) in list"
            :key="index" class="listitem flex align-center justify-center">
            <i :id="'icon'+item.id" style="font-size: 18px;" :class="item.way?'iconfont '+item.icon+' ':item.icon"></i>
            <span class="listitem-text flex align-center">{{item.text}}</span>
          </div>

        </el-aside>
        <!-- Main 主体内容 -->
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>

    <!-- 兀兔公告 -->
    <el-dialog id="wtgg" title="兀兔公告" :visible.sync="dialogVisible" width="45%">
      <div class="flex justify-between align-center">
        <p style="color: #333333;font-size: 14px;">公告</p>
        <div class="flex">
          <el-button plain>全部已读</el-button>
          <el-button plain>仅看未读</el-button>
        </div>
      </div>
      <el-collapse @change='clickGgList' style="margin-top: 24px;" v-model="activeName" accordion>
          <el-collapse-item v-for="(item,index) in Gglist" :key='index' :name="item.id">
            <template slot="title">
             <span :class="item.read?'yuan_white':'yuan_red'" class="yuan"></span> 一致性 Consistency
            </template>
            <div style="padding-left: 24px;">{{item.content}}</div>
          </el-collapse-item>
      </el-collapse>

      <el-pagination slot="footer" style="margin-top: 30px;text-align: center;" background
        @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[100, 200, 300, 400]"
        layout="total, prev, pager, next, jumper" :total="400">
      </el-pagination>
    </el-dialog>


    <!-- 发布公告 -->
    <el-dialog
      title="兀兔公告"
      :visible.sync="dialogVisible1"
      width="45%"
      id="FBgg"
      >
      <el-input
        type="textarea"
        :rows="20"
        placeholder="请输入内容"
        v-model="textarea">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button style="height: 32px;padding: 9px 20px;background-color: #F5F6F7;" @click="dialogVisible1 = false">取 消</el-button>
        <el-button style="height: 32px;padding: 9px 20px;background-color: #1BADE8;color: #FFFFFF;" type="primary" @click="userMsg">发 布</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

  export default {
    name: 'Home',

    data() {
      return {
        login_name:localStorage.getItem('u_name'),
        
        /*发布公告 */
        dialogVisible1:false,
        textarea:'',
        msgObj:{
          act:'userMsg',
          content:''
        },

        //*******************************兀兔公告
        dialogVisible: false,
        activeName: '0',
        currentPage4: 4,
        Gglist:[
          {
            id:1,
            title:'我是标题1',
            content:'我是内容1',
            read:false
          },
          {
            id:2,
            title:'我是标题2',
            content:'我是内容2',
            read:false
          },
          {
            id:3,
            title:'我是标题3',
            content:'我是内容3',
            read:true
          },
        ],

        //*******************************
        current: localStorage.getItem('current'),
        list: [{
            id: 1,
            text: '首页',
            icon: 'el-icon-s-home'
          },
          {
            id: 2,
            text: '用户中心',
            icon: 'el-icon-user-solid'
          },
          {
            id: 3,
            text: '使用情况',
            icon: 'el-icon-s-order'
          },
          {
            id: 4,
            text: '算价中心',
            icon: 'icon--shoufeiguanli',
            way:'ali'
          },
          {
            id: 5,
            text: '激活码管理',
            icon: 'icon-wodeduihuanma',
            way:'ali'
          },
          {
            id: 6,
            text: '工单管理列表',
            icon: 'icon-baogaogongdan',
            way:'ali'
          }
        ]
      }
    },
    methods: {
      /* 公告 */
      userMsg(){
        this.$api.dataList.userTable({
          act:'userMsg',
          content:this.textarea
        }).then(res=>{
          console.log('发布公告:',res)
          if(res.code=='1'){
            this.$message({
              message: res.info,
              type: 'success'
            })
            this.dialogVisible1=false
          }else{
            this.$message({
              message: res.info,
              type: 'error'
            })
          }
        })
      },
      getMsg(){
        this.dialogVisible1=true
        this.$api.dataList.userTable({
          act:'userMsg'
        }).then(res=>{
          console.log('获取公告：',res)
          if(res.code=='1'){
            this.textarea=res.data.content
          }
        })
      },


      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
      gopage(id) {
        let that = this
        localStorage.setItem('current',id)
        this.current = id
        switch (id) {
          case 1:
            that.$router.push("/")
            break;
          case 2:
            that.$router.push("/userCenter")
            break;
          case 3:
            that.$router.push("/usage")
            break;
          case 4:
            that.$router.push("/pricingCenter")
            break;
          case 5:
            that.$router.push("/activationCode")
            break;
          case 6:
            that.$router.push("/workOrder")
            break;
          default:
            break;
        }
      },
      /* 退出 */
      signOut(){
        this.$confirm('是否确认退出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.clear()
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
          this.$router.push("/Login")
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消退出'
          });
        });
      },
      /* 点击公告-已读 */
      clickGgList(e){
        console.log(e)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* 引入阿里icon */
@import '//at.alicdn.com/t/font_2704137_sjcazhxcqwo.css';

</style>

<style>
  .el-header {
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-aside {
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    background-color: #F5F6FA;
    color: #333;
    text-align: center;
    min-width: 1600px;
    /* line-height: 160px; */
  }


  /****************/
  #wtgg .el-dialog,
  #xttz .el-dialog {
    padding: 24px;
    border-radius: 8px;
  }

  #wtgg .el-dialog__header,
  #xttz .el-dialog__header {
    padding: 0;
    padding-bottom: 12px;
    border-bottom: 1px solid #F5F6F7;
  }

  #wtgg .el-dialog__title,
  #xttz .el-dialog__title {
    color: #333333;
    font-size: 14px;
    font-weight: 700;
  }

  #wtgg .el-dialog__headerbtn,
  #xttz .el-dialog__headerbtn {
    font-size: 18px;
  }

  #wtgg .el-button,
  #xttz .el-button {
    height: 32px;
    padding: 0 20px;
  }

  #wtgg .el-dialog__body,
  #xttz .el-dialog__body {
    padding: 0;
    padding-top: 16px;
  }

  #wtgg .el-collapse-item__header,
  #xttz .el-collapse-item__header {
    color: #666666;
  }
  #Home .el-container {
    height: 100%;
  }
  #Home #home-btn {
    width: 76px;
    height: 32px;
    background: linear-gradient(136deg, #3AD6F5 0%, #1BADE8 100%);
    border-radius: 2px;
    padding: 0;
    margin-right: 40px;
    color: #FFFFFF;
    text-shadow: 2px 2px 3px rgba(3, 122, 166, 0.68);
  }

  .listitem {
    width: 200px;
    height: 68px;
    cursor: pointer;
    overflow: hidden;
  }
  .listitem:hover {
    background-color: #dad6d6 !important;
  }
  .isactive.listitem:hover {
    background-color: #1BADE8 !important;
    color: #FFFFFF !important;
  }
  .listitem-text {
    width: 90px;
    text-align: left;
    font-size: 14px;
    margin-left: 24px;
    height: 20px;
  }
  .isactive {
    background-color: #1BADE8 !important;
    color: #FFFFFF !important;
  }
  #icon5{
    font-size: 12px !important;
  }
  .yuan {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
    display: inline-block;
  }
  .yuan_red{
    border-color: red;
    background-color: red;
  }
  .yuan_white{
    background-color: white;
    border-color: white;
  }
  .el-collapse-item{
    width: 100%;
  }
  .el-collapse-item__header{
    padding-left: 12px;
  }

  /* 发布公告 */
  #FBgg .el-dialog{
    border-radius: 8px;
    overflow: hidden;
    padding: 20px;
  }
  #FBgg .el-dialog__header{
    padding: 0;
    border-bottom: 1px solid #F5F6F7;
    padding-bottom: 16px;
  }
  #FBgg .el-dialog__title{
    color: #333333;
    font-size: 14px;
  }
  #FBgg .el-dialog__body{
    padding: 0;
    margin-top: 24px;
  }
  #FBgg .el-dialog__footer{
    padding: 0;
    margin-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue